import { forwardRef, Ref } from "react"

import { Button } from "../../button"

import { SelectActionProps } from "./types"

export const SelectAction = forwardRef(
  (props: SelectActionProps, ref: Ref<HTMLButtonElement>) => {
    // @ts-ignore to get rid of ref typing error
    return <Button ref={ref} {...props} />
  },
)
